// extracted by mini-css-extract-plugin
export default {"sticky":"Navigation__sticky--lc-ZIwFw"};